import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from 'DesignLibrary/atoms';
import Text from 'Shared/Text';
import { PROFILE_PATH } from 'Utils/urls';

const ProfileNavigator = () => {
  const navigate = useNavigate();
  return (
    <Button
      className=""
      size="small"
      onClick={() => navigate(PROFILE_PATH)}
      data-testid="navigate-to-profile-btn"
      iconLeft="PencilSimple"
      iconProps={{ color: '--text-black' }}
      color="white"
    >
      <Text field="health_section.button_text.editProfile" />
    </Button>
  );
};

export default ProfileNavigator;
